// extracted by mini-css-extract-plugin
export var bodyContainer = "modalacademypromo-module--body-container--aee86";